const Switch = ({ checked, onChange }) => {
  return (
    <button
      onClick={() => onChange(!checked)}
      className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors duration-300
        ${checked ? "bg-highlight" : "bg-gray-300"}`}
    >
      <span
        className={`inline-block h-3 w-3 transform rounded-full bg-white transition-transform duration-300
          ${checked ? "translate-x-5" : "translate-x-1"}`}
      />
    </button>
  );
};

export default Switch;
